<template>
    <div class="month-select-title">
        <span class="iconfont iconrili" @click="showCalendar"></span>
        <span v-text="tit"></span>
    </div>
</template>
<script>
export default {
    name: 'month-select-title',
    components: {},
    props: {
        tit: {
            type: [String],
        },
    },
    data() {
        return {
            currentDate: '',
            show: false,
        };
    },
    watch: {},
    computed: {},
    methods: {
        showCalendar() {
            // this.show = true;
            this.$emit('change-month');
        },
        // 时间格式化
        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } if (type === 'month') {
                return `${val}月`;
            }
            return val;
        },
    },
    created() {},
    mounted() {},
};
</script>
<style lang="stylus" scoped>
.month-select-title
    width 100%
    height 30rpx
    background #F0F0F0
    font-size 12rpx
    text-align center
    line-height 30rpx
    position fixed
    top 44rpx
    .iconrili
        font-size 18rpx
        margin-right 6rpx
        cursor pointer
        color: #5588F1;
</style>